import MainLayout from '../pages/Layout/MainLayout.vue';

const HomePage = () => import('../pages/Home/Home.vue');
const Club = () => import('@/pages/Venues/Club');
const BeachClubs = () => import('@/pages/Venues/BeachClubs');
const Clubs = () => import('@/pages/Venues/Clubs');
const PartyCalendar = () => import('@/pages/PartyCalendar/PartyCalendar');
const Event = () => import('@/pages/Events/Event');
const ClubEvent = () => import('@/pages/Events/ClubEvent');
const LosCabosSpringBreak = () =>
  import('@/pages/SpringBreak/LosCabosSpringBreak');

const About = () => import('@/pages/About/About');
const Faq = () => import('@/pages/Faq/Faq');
const Article = () => import('@/pages/Article/Article');
const Blog = () => import('@/pages/Article/Blog');
const Redirector = () => import('@/pages/Redirector/Redirector');
const CaboShorts = () => import('@/pages/CaboShorts/CaboShorts');
const Dinners = () => import('@/pages/Dinners/Dinners');
const Reservations = () => import('@/pages/Reservations/ReservationsPage');
const CaboNightLife = () => import('@/pages/CaboNightLife/CaboNightLife');
const ClubsDirectory = () => import('@/pages/Venues/ClubsDirectory');
const DjSchedule = () => import('../pages/DjSchedule/DjSchedule');
const Artists = () => import('../pages/Artists/Artists');
const Artist = () => import('../pages/Artists/Artist');

// const ClubReservations = () => import('@/pages/Venues/ClubReservations');
const CaboNye2025 = () => import('@/pages/NYE/CaboNye2025');
const ConciergeServices = () =>
  import('@/pages/ConciergeServices/ConciergeServices');
import redirects from '@/pages/redirects';
const Today = () => import('@/pages/Today/Today');

// GeneralViews
// import NotFound from 'template_reference/GeneralViews/NotFoundPage.vue';

const routes = [
  {
    path: '/',
    component: MainLayout,
    name: 'Main',
    redirect: {
      name: 'Home',
    },
    children: [
      // Redirects
      ...redirects,
      {
        path: '/',
        name: 'Home',
        component: HomePage,
      },
      {
        path: '/event/:slug',
        name: 'Event',
        component: Event,
        props: (route) => ({ slug: route.params.slug }),
      },
      {
        path: '/los-cabos-clubs/:club/event/:slug',
        name: 'ClubEvent',
        component: ClubEvent,
        props: (route) => ({
          slug: route.params.slug,
          clubSlug: route.params.club,
        }),
      },
      {
        path: '/about',
        name: 'About',
        components: { default: About },
      },
      {
        path: '/los-cabos-mexico-event-calendar',
        name: 'PartyCalendar',
        // meta: { hideFooter: true},
        component: PartyCalendar,
        props: (route) => ({ slug: route.params.slug }),
      },
      {
        path: '/calendar',
        redirect: () => {
          return '/los-cabos-mexico-event-calendar';
        },
      },
      {
        path: '/los-cabos-clubs',
        name: 'Clubs',
        component: Clubs,
      },
      {
        path: '/los-cabos-clubs/:slug',
        name: 'Club',
        component: Club,
        props: (route) => ({ slug: route.params.slug }),
      },
      // {
      //   path: '/los-cabos-clubs/:slug/reservations',
      //   name: 'ClubReservations',
      //   component: ClubReservations,
      //   props: (route) => ({slug: route.params.slug}),
      // },
      {
        path: '/los-cabos-beach-clubs',
        name: 'BeachClubs',
        component: BeachClubs,
      },
      {
        path: '/los-cabos-clubs-directory',
        name: 'ClubsDirectory',
        component: ClubsDirectory,
      },
      {
        path: '/blog',
        name: 'Blog',
        component: Blog,
      },
      {
        path: '/los-cabos-nightlife',
        name: 'CaboNightLife',
        component: CaboNightLife,
      },
      {
        path: '/article/:slug',
        name: 'Article',
        component: Article,
        props: (route) => ({ slug: route.params.slug }),
      },
      {
        path: '/faq',
        name: 'FaqShort',
        redirect: () => {
          return '/los-cabos-traveler-frequent-questions';
        },
      },
      {
        path: '/los-cabos-traveler-frequent-questions',
        name: 'Faq',
        component: Faq,
      },
      {
        path: '/los-cabos-dinner-table-reservations',
        name: 'Dinners',
        component: Dinners,
      },
      {
        path: '/reservations',
        name: 'Reservations',
        component: Reservations,
      },
      {
        path: '/los-cabos-shorts/:slug',
        name: 'CaboShort',
        component: CaboShorts,
        props: (route) => ({ slug: route.params.slug }),
      },
      {
        path: '/l',
        name: 'Redirector',
        component: Redirector,
        props: (route) => ({ slug: route.query.u }),
      },
      {
        path: '/google-calendar-party',
        name: 'GoogleCalendar',
        beforeEnter() {
          let calendarId =
            'Y19mNWU3NjQ5YTliN2U1NTg2Mzg2MmM2MTM3NGYyMzQ1NGVjOTk0ZDJjM2E1NzkxY2E2ZDI5MDZmYjg3YjI0ZWVhQGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20';
          let title = 'cabo%20party%20calendar';
          let ctz = 'America%2FMazatlan';
          window.location.href = `https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=${ctz}&bgcolor=%23ffffff&showPrint=0&mode=AGENDA&color=%23000000&title=${title}&src=${calendarId}`;
        },
      },
      {
        path: '/calendar',
        redirect: () => {
          return '/google-calendar-party';
        },
      },
      {
        path: '/los-cabos-dj-schedule',
        name: 'DjSchedule',
        components: { default: DjSchedule },
      },
      {
        path: '/djs',
        name: 'Artists',
        components: { default: Artists },
      },
      {
        path: '/djs/:slug',
        name: 'Artist',
        component: Artist,
        props: (route) => ({ slug: route.params.slug }),
      },
      {
        path: '/los-cabos-party-new-year-celebration-2025',
        name: 'LosCabosNye2025',
        component: CaboNye2025,
      },
      {
        path: '/los-cabos-spring-break',
        name: 'LosCabosSpringBreak',
        component: LosCabosSpringBreak,
      },
      {
        path: '/los-cabos-events-today',
        name: 'Today',
        component: Today,
      },
      {
        path: '/today',
        redirect: () => {
          return '/los-cabos-events-today';
        },
      },
      {
        path: '/los-cabos-concierge-services',
        name: 'ConciergeServices',
        component: ConciergeServices,
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

export default routes;
